import { Bounce, toast } from 'react-toastify';

export function toastSuccess(message: string, autoClose = 10000) {
	toast.success(message, {
		position: 'top-center',
		autoClose,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: 'colored',
		transition: Bounce,
	});
}

export function toastError(message: string, autoClose = 10000) {
	toast.error(message, {
		position: 'top-center',
		autoClose,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: 'colored',
		transition: Bounce,
	});
}

export const toastErrorMultiline = (message: string) => {
	toast.error(<div style={{ whiteSpace: 'pre-line' }}>{message}</div>, {
		position: 'top-center',
		autoClose: 2000,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: 'colored',
		transition: Bounce,
	});
};
